import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import movies from "./modules/movies";

const state = {
  csrf: '',
};

const actions = {
  init({ commit }) {
    const csrfMeta = document.querySelector('meta[name="csrf-token"]');

    commit('SET_CSRF_TOKEN', csrfMeta.getAttribute('content'));
  },
};

const mutations = {
  SET_CSRF_TOKEN: (state, data) => state.csrf = data,
};

const modules = {
  movies,
};

export default new Vuex.Store({
  namespaced: true,
  state,
  actions,
  mutations,
  modules
});
